/**
 *
 * MatchedLabels
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import _isEmpty from 'lodash/isEmpty';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    overflow: 'hidden',
    height: 22,
  },
  wrapper: {
    backgroundColor: '#2899C2',
    height: 22,
    paddingLeft: 6,
    paddingRight: 6,
    borderRadius: 2,
    display: 'flex',
    alignItems: 'center',
    marginLeft: 2,
    marginRight: 2,
    '&:first-child': {
      marginLeft: 0,
    },
    '&:last-child': {
      marginRight: 0,
    },
  },
  label: {
    color: '#FFFFFF',
    fontFamily: 'PoppinsSemiBold',
    fontSize: '0.75rem',
    letterSpacing: 'normal',
  },
});

function MatchedLabels({ labels }) {
  const classes = useStyles();
  if (_isEmpty(labels)) return null;

  return (
    <div className={classes.root}>
      {labels.map(label => (
        <div className={classes.wrapper} key={label}>
          <span className={classes.label}>{label}</span>
        </div>
      ))}
    </div>
  );
}

MatchedLabels.propTypes = {
  labels: PropTypes.array,
};

export default MatchedLabels;
